const FALLBACK_STICKY_NAV_OFFSET = 88;
const SCROLL_PADDING = 16;

const getStickyNavOffset = () => {
  const nav = document.querySelector("nav");

  if (!nav) {
    return FALLBACK_STICKY_NAV_OFFSET;
  }

  return nav.getBoundingClientRect().height + SCROLL_PADDING;
};

export const scrollToSection = (id: string, animate: boolean) => {
  const section = document.getElementById(id);

  if (section) {
    const stickyNavOffset = getStickyNavOffset();

    window.scrollTo({
      top:
        section.getBoundingClientRect().top +
        window.scrollY -
        stickyNavOffset,
      behavior: animate ? "smooth" : "auto",
    });
  }
};
